<ng-container *ngIf="!print">
  <ng-container *ngIf="!noBorder">
    <div class="top">
      <div class="selection">
        <input #textinput
          [ngClass]="{'no-border': noBorder, 'nrk-disabled-background': disabled }"
          type="text" 
          [placeholder]="placeholder || ''" 
          (click)="onClick($event)" 
          (keyup)="onKeyUp($event)"
          (blur)="onBlur($event)"
          [value]="textValue || value"
          (valueChange)="textValue = value = $any($event)"
          [attr.disabled]="disabled ? '' : null" />
      </div>
      <div class="closebtn" *ngIf="!noClear && !disabled">
        <button [ngClass]="{'no-border': noBorder, 'nrk-doc-button': true}" (click)="clear()" title="clear">X</button>
      </div>
    </div>
    <div class="container options-table">
      <div #popup class="popup" *ngIf="_showPopup" [style.width.px]="popupWidth" (document:click)="onDocClick($event)">
        <!-- <ul>
          <ng-container #listItems *ngFor="let o of filter(currentValue); let idx = index">
            <li [ngClass]="{'ruler': o?.id == dummyId}">
              <div *ngIf="o?.id == dummyId"></div>
              <div *ngIf="o?.id != dummyId" [ngClass]="{'option': true, 'selected': idx == selectedIndex}" (click)="onSelect(idx)">
                {{o?.name == '' ? '&nbsp;' : o?.name}}
              </div>
            </li>
          </ng-container>
        </ul> -->
        <table>
          <ng-container *ngFor="let o of filter(currentValue); let idx = index">
            <tr *ngIf="o.id == dummyId"><td class="ruler"></td></tr>
            <ng-container *ngIf="o.id != dummyId">
              <tr #listItems (mousedown)="onSelect($event, idx)" [ngClass]="{'option': true, 'selected': idx == selectedIndex}" >
                <td *ngFor="let col of o.cols">{{col == '' ? '&nbsp;' : col}}</td>
              </tr>
            </ng-container>
          </ng-container>
        </table>
        <div *ngIf="!filter(currentValue) || filter(currentValue).length == 0">
          &nbsp;&nbsp;no Data
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="noBorder">
    <div class="row">
      <div class="col-4"><label>{{title}}</label></div>
      <div class="col-8">
        <div class="form-group">
          <div class="top">
            <div class="selection">
              <input #textinput
                [ngClass]="{'nrk-disabled-background': disabled, 'form-control': true, 'form-control-sm': true }"
                type="text" 
                [placeholder]="placeholder || ''" 
                (click)="onClick($event)" 
                (keyup)="onKeyUp($event)" 
                (blur)="onBlur($event)"
                [value]="textValue"
                (valueChange)="textValue"
                [attr.disabled]="disabled ? '' : null" />
            </div>
            <div class="closebtn" *ngIf="!noClear && !disabled">
              <button [ngClass]="{'no-border': noBorder, 'nrk-doc-button': true}" (click)="clear()" title="clear">X</button>
            </div>
          </div>
          <div class="container-noborder options-table">
            <div #popup class="popup" *ngIf="_showPopup" [style.width.px]="popupWidth" (document:click)="onDocClick($event)">
              <table>
                <ng-container *ngFor="let o of filter(currentValue); let idx = index">
                  <tr *ngIf="o.id == dummyId"><td class="ruler"></td></tr>
                  <ng-container *ngIf="o.id != dummyId">
                    <tr #listItems (mousedown)="onSelect($event, idx)" [ngClass]="{'option': true, 'selected': idx == selectedIndex}" >
                      <td *ngFor="let col of o.cols">{{col == '' ? '&nbsp;' : col}}</td>
                    </tr>
                  </ng-container>
                </ng-container>
              </table>
              <div *ngIf="filter(currentValue)?.length == 0">
                &nbsp;&nbsp;no Data
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>  
  </ng-container>
</ng-container>

<div *ngIf="print">
  {{textValue}}
</div>